
<div class="board-labels-container">
  <div class="general-labels">
    <div class="label mt-2 mb-1">General Labels</div>
    <p>Here you can select which labels should be available for selection on the board.</p>
    <div class="content-container ob-scroll">
      <div class="font-weight-bold container-fluid">
        <div class="row pt-2">
          <div class="col-3">Category</div>
          <div class="col-4">Label</div>
          <div class="col-2">Available</div>
        </div>
        <div class="row pt-2">
          <div class="col-2 offset-7">
            <checkbox-with-label
              v-model="isGeneralLabelsSelectedAll_"
              :label="isGeneralLabelsSelectedAll ? 'Unselect all' : 'Select all'"
              @input="toggleAllGeneralLabels(isGeneralLabelsSelectedAll)"
            ></checkbox-with-label>
          </div>
        </div>
      </div>

      <div class="container-fluid pt-2 pb-2">
        <div class="row pt-2 pb-1" v-for="bl in selectableGeneralBoardsLabels" :key="bl.id">
          <div class="col-3">
            {{ bl.category }}
          </div>
          <div class="col-4">
            <div class="d-flex">
              <div
                class="bi-label mr-2 mb-1 d-flex justify-content-between align-items-center"
                :style="{
                  'background-color': bl.color,
                  color: 'white',
                  padding: '1px 3px',
                  'border-radius': '3px',
                }"
              >
                <i v-if="bl.icon" :class="bl.icon" class="mr-1 ml-1 pr-1"></i>
                <div class="pl-1 pr-1">
                  {{ bl.title }}
                </div>
              </div>
            </div>
          </div>

          <div class="col-2">
            <checkbox-with-label label="Available" v-model="bl.isAvailable"></checkbox-with-label>
          </div>
        </div>
      </div>
    </div>

    <div class="d-flex justify-content-end pt-2">
      <button :disabled="isLoading" class="btn btn-save btn-sm btn-success" @click="saveGeneralBoardsLabels()">
        <i class="far fa-save"></i>
        Save changes
      </button>
    </div>
  </div>
  <hr />
  <div class="board-labels mt-4">
    <BoardsLabels />
  </div>
</div>
